import * as v3 from './v3/endpoints';
import * as v5 from './v5/endpoints';

const impl = process.env.NODE_CONFIG?.backend?.version === 'v5' ? v5 : v3;

export const { form, task, answer, certification } = impl;
